import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Components/CSS/BlogCard.module.css';
import { useBlogs } from '../hooks/useBlogs';
import useBlogStore from '../store/blogsStore';

const BlogCard = () => {
  const navigate = useNavigate();
  const { blogs, isLoading, error, refetchBlogs } = useBlogs();
  const { visibleCards, incrementVisibleCards } = useBlogStore();

  // Add this useEffect to handle initial data fetching
  useEffect(() => {
    refetchBlogs();
  }, [refetchBlogs]);

  const stripHtmlTags = (html) => {
    return (html || '').replace(/<[^>]*>/g, '');
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Date not available';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  if (isLoading) {
    return <div className={styles.loading}>Loading...</div>;
  }

  if (error) {
    return <div className={styles.error}>Error loading blogs</div>;
  }

  if (!blogs?.blogs || blogs.blogs.length === 0) {
    return (
      <div className={styles.noBlogsContainer}>
        <p className={styles.noBlogs}>No blogs available at the moment</p>
      </div>
    );
  }

  const blogPosts = blogs.blogs;

  return (
    <>
      <div className={styles.cardGrid}>
        {blogPosts.slice(0, visibleCards).map((blog) => {
          const plainTextContent = stripHtmlTags(blog.content);
          const preview = plainTextContent
            .split(/\s+/)
            .slice(0, 15)
            .join(" ") + "...";

          return (
            <div key={blog.id} className={styles.card} onClick={() => navigate(`/blog/${blog.slug}`)} >
              <div className={styles.imageContainer}>
                <a href="#" className={styles.category}>
                  {blog.category || 'Uncategorized'}
                </a>
                {blog.featuredImage ? (
                  <img 
                    src={blog.featuredImage} 
                    alt={blog.title} 
                    className={styles.image}
                  />
                ) : (
                  <div className={`${styles.image} ${styles.placeholderImage}`}>
                    No image available
                  </div>
                )}
              </div>

              <div className={styles.content}>
                <h3 className={styles.title}>
                  {blog.title.length > 40 ? `${blog.title.slice(0, 40)}...` : blog.title}
                </h3>
                <div className={styles.divider}></div>

                <div className={styles.authorSection}>
                  <div className={styles.author}>
                    <div className={styles.avatarPlaceholder}>
                      {blog.author?.name?.charAt(0) || '?'}
                    </div>
                    <span>{blog.author?.name || 'Unknown Author'}</span>
                  </div>
                  <span className={styles.date}>
                    {formatDate(blog.createdAt)}
                  </span>
                </div>

                <p className={styles.description}>{preview}</p>
              </div>
            </div>
          );
        })}
      </div>

      {blogPosts.length > visibleCards && (
        <div className={styles.loadMoreContainer}>
          <button onClick={() => incrementVisibleCards()} className={styles.loadMoreButton}>
            Load More
          </button>
        </div>
      )}
    </>
  );
};

export default BlogCard;